/**
 * @generated SignedSource<<0bf41ee0d755a02fae884a66b5731418>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BranchPickerRepositoryBranches$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"BranchPickerRef">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "BranchPickerRepositoryBranches";
};
export type BranchPickerRepositoryBranches$key = {
  readonly " $data"?: BranchPickerRepositoryBranches$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchPickerRepositoryBranches">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "BranchPickerRepositoryBranches"
};

(node as any).hash = "fc20fd3ed00706559cd5314915dda570";

export default node;
